import type { SVGProps } from 'react';

const SvgWarningFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 13.3018C11.5031 13.3016 11.0996 12.8983 11.0996 12.4014V7.90137C11.0998 7.4046 11.5032 7.00115 12 7.00098C12.4969 7.00098 12.9002 7.40449 12.9004 7.90137V12.4014C12.9004 12.8984 12.4971 13.3018 12 13.3018ZM12 16.9014C11.4478 16.9013 11 16.4536 11 15.9014C11.0002 15.3493 11.4479 14.9015 12 14.9014C12.5522 14.9014 12.9998 15.3493 13 15.9014C13 16.4537 12.5523 16.9014 12 16.9014Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgWarningFilled;
